import { Message } from 'primeng/api';

export interface Formatters {
  date: DateFormat;
}

export interface DateFormat {
  dateFormat: string;
  placeholder: string;
}

export interface Editor {
  height: string;
}

export interface Quill {
  toolbar: Container;
}

export interface Container {
  container: Array<any>;
}

export interface IFileData {
  BUSINESSREGISTRATION: string;
  PROOFOFQUALIFICATION: string;
  PROOFOFEXPERTISE: string;
  PROOFOFCONTRACT: string;
  ENTRYINTRADEREGISTER: string;
  ENTRYATCHAMBEROFHANDICRAFTS: string;
  PROOFOFINDEMNITYINSURANCE: string;
  IDCARDMAINFRAUD: string;
  WELDINGCERTIFICATECONFIRMATION: string;
  PROOF80HOURSTRWI: string;
  ONEDAYTRAININGTRGI2018: string;
  ONEDAYTRAININGTRWI: string;
  GASCOURSECENTRALHEATINGVENTILATIONDURATION: string;
  PROOF100HOURSTRGI: string;
  WELDINGCERTIFICATECONFIRMATIONNOTREQUIRED: string;
  SAFETYTECHNOLOGYAUTHORIZATION: string;
}

export interface KeyValueData {
  [key: string]: string;
}

export interface FormTypesData {
  childElement: string;
  index: number;
  key: string;
  lookUpKey?: string;
}

export interface UserInfo {
  status: string;
  technician_id: string;
  user_email: string;
  role: string;
}

export interface User {
  title: string;
  telephone: string;
  mail: string;
  technician_id: string;
  status: string;
  role: string;
  meisterpruefung_date: string;
  meisterpruefung_bei: string;
  last_name: string;
  first_name: string;
  email: string;
  concession_water: boolean;
  concession_valid_until: string;
  concession_power: boolean;
  concession_gas: boolean;
  concession_district_heating: boolean;
  birthday: string;
  company_id: string;
}

export interface UserRegistrationResponse {
  created?: {
    technician_id: string;
  }[];
  error?: string;
  status?: string;
}

export interface UserLoginResponse {
  login: {
    result: string;
    technician_id: string;
    technician: User[];
  }[];
}

export interface ApplicationResponseData {
  technician_application: TechnicianApplicationData[];
}

export interface TechnicianApplicationData {
  company_id: string;
  ta_id: string;
  technician_id: string;
  status: string;
  reasonDescription: string;
  qualification_type?: string;
  locked: string;
  lockedby: string;
  technician: TechnicianData[];
  document: DocumentData[];
  company: CompanyData[];
}

export interface TechnicianData {
  role?: string;
  technician_id?: string;
  company_id?: string;
  sk_title?: string;
  telephone?: string;
  status?: string;
  meisterpruefung_date?: string;
  meisterpruefung_bei?: string;
  last_name?: string;
  first_name?: string;
  email?: string;
  concession_water?: string;
  concession_valid_until?: string;
  concession_power?: string;
  concession_gas?: string;
  concession_district_heating?: string;
  birthday?: string;
  company?: CompanyData[];
  concessions_expired?: string;
  qualification_type?: string;
  welding_license?: string;
  education_information?: any;
}

export interface ConcessionData {
  concession_id: string;
  technician_id: string;
  concession_power: string;
  concession_gas: string;
  concession_water: string;
  concession_district_heating: string;
  expiration_date: string;
  status: string;
  is_document_uploaded: string;
}

export interface CompanyData {
  telephone: string;
  tax_id?: string;
  subsidiary: string;
  street_number: string;
  street: string;
  registered_network_operator?: string;
  postcode: string;
  headoffice: string;
  company_name: string;
  company_id?: string;
  city: string;
  ceo: string;
  cs_district_number?: string;
  auxiliary_company: string;
  headsubsidiary?: string;
  main_businesses_part_time?: string;
  in_auxiliary_operation?: string;
}

export interface DocumentData {
  ta_id: string;
  document_id: string;
  name?: string;
  filename?: string;
  filesize: any;
}

export interface ResponseMessageModel extends Message {
  data: {
    msgType: string;
  };
}

export enum Errors {
  // noinspection JSUnusedGlobalSymbols
  Error = 'error',
  Denied = 'denied',
}

export enum EntityType {
  Attachment = 'attachments',
  Inverter = 'inverters',
  Generator = 'generators',
  Storage = 'storages',
  Document = 'document',
  Area = 'area',
}

export interface DownloadCenterDocument {
  document: {
    document_id: string;
    name: string;
    filename: string;
    content_type: string;
  }[];
}

export interface ExampleDocumentResponse {
  document: ExampleDocument[];
}

export interface ExampleDocument {
  document_id: string;
  name: string;
  filename: string;
  content_type: string;
  sk_document_type: string;
}

export interface Area {
  devarea: {
    area_id: string;
    name: string;
    power: string;
    gas: string;
    water: string;
    districtheat: string;
  }[];
}

export interface AreaResponse {
  developmentarea: {
    area_id: string;
  }[];
}

export interface UpdateLockStatusResponse {
  technician_application: {
    company_id: string;
    creation_id: string;
    locked: string;
    lockedby: string;
    qualification_type: string;
    read_status: string;
    reasonDescription: string;
    status: string;
    ta_id: string;
    technician_id: string;
  }[];
}

export interface TableConfiguration {
  rowsPerPageOptions: number[];
  rowsPerPage: number;
}

export interface MessageCount {
  message: {
    count: string;
  }[];
}
